import React from 'react'
import { ResultDisplayProps } from '../common'
import { DefaultMeetingResultEditView } from './DefaultMeetingResultEditView'
import { Button } from '../../../../../../components/Button/Button'
import { DefaultMeetingResultView } from './DefaultMeetingResultView'
import { useEditingAiResult } from './hooks'
import { useAppSelector } from '../../../../../../store/hooks'
import { selectAiResultSaveLoading } from '../../../../../../store/meetingSummary/aiResults'
import { selectEditingAiResultIds } from '../../../../../../store/meetingSummary/display'

export const DefaultResultDisplay: React.FC<ResultDisplayProps> = ({ aiFeature, aiResult: displayedAiResult, showEditButtons }) => {
  const isResultSaveLoading = useAppSelector(selectAiResultSaveLoading)
  const editingAiResultIds = useAppSelector(selectEditingAiResultIds)

  const {
    aiResult,
    editingAiResult,
    handleResultTextContentChanged,
    handleFormattedResultChanged,
    handleReadOnlyFormattedResultChanged,
    handleCancel,
    handleSave,
  } = useEditingAiResult(aiFeature, displayedAiResult)

  if (editingAiResultIds.includes(aiResult.id)) {
    return (
      <>
        <div className='default-edit-result-container p-3 mb-4'>
          <DefaultMeetingResultEditView
            aiFeature={aiFeature}
            aiResult={editingAiResult}
            onResultTextContentChange={handleResultTextContentChanged}
            onFormattedResultChange={handleFormattedResultChanged}
          />
        </div>
        {showEditButtons ? (
          <div className='d-flex gap-3 justify-content-end'>
            <Button variant='secondary' className='button-small' onClick={handleCancel} disabled={isResultSaveLoading}>
              Cancel
            </Button>
            <Button variant='primary' className='button-small' onClick={handleSave} disabled={isResultSaveLoading}>
              Save
            </Button>
          </div>
        ) : null}
      </>
    )
  }

  return <DefaultMeetingResultView aiFeature={aiFeature} aiResult={aiResult} onFormattedResultChange={handleReadOnlyFormattedResultChanged} />
}
